import * as gl from 'glance-datatypes';

class Constants {
  public static SERVER_END_POINT = 'http://localhost:8080/';
  public static PARTNER_API_PATH = 'api/glance/partner/';
  public static PUBLISH_API_PATH = 'api/glance/data/';
  public static DRAFT_API_PATH = 'api/glance/draft/';
  public static PARTNER: gl.Partner = new gl.Partner({
    partnerId: 'fa647c9e01a2defa9fdc483a9a3352d003cb003d',
    name: 'ZTE',
  });
  public static CDN_PREFIX = 'https://gcs.dev.glance.com/public/';
  // public static setCdnPrefix(value: string) {
  //     Constants.CDN_PREFIX = value
  // }
  public static GAMBIT_URL_DEV = 'https://gambit-dev.glance.inmobi.com';
  public static GAMBIT_URL_STAGING = 'https://gambit-staging.glance.inmobi.com';

  public static GAMBIT_URL_PROD = 'https://gambit.glance.inmobi.com';

  public static CONTEXTUAL_EMOJI_PROD =
    'https://glance-tv-interaction.glance.inmobi.com';
  public static CONTEXTUAL_EMOJI_STAGING =
    'https://glance-tv-interaction-staging.glance.inmobi.com';
  public static CONTEXTUAL_EMOJI_DEV =
    'https://glance-tv-interaction-staging.glance.inmobi.com';
  public static CONTENT_FOR_APPS = '#content_for_apps';
  public static CONTENT_CARDS_ADMINS = [
    'bharat.p',
    'rohan.kini',
    'jatin.choyal',
    'nikhil.mukundan',
    'premanand.maharana',
    'puneet.aggarwal',
    'ram.prasad',
    'suman.reddy',
    'gaurav.saini',
  ];
  public static BEACON_PARTNERS = [
    'Appsflyer',
    'Branch',
    'Firebase',
    'Kochava',
    'DCM',
    'Sizemek',
    'DV',
    'Neilson',
    'None'
  ];
}

export class Partners {
  public static SAMSUNG_ANDROID_PARTNER_ID =
    '16b66d7123dd588670e011bbb88bec9c0a27359c';
  public static TEST_PARTNER_ID = 'test-partner-id';
  public static VIVO_PARTNER_ID = 'feb4e5ad0039fee86e4870dd3ca88c28a8ee1a1e';
  public static OPPO_PARTNER_ID = 'd1f143bd74d8977c781204281564a93f';
  public static OPPO_API_PARTNER_ID = 'b27cbb02e015198844783efe6db1d580';
  public static TRANSSION_PARTNER_ID = "b366fc7948b55d41976cf3014f616f6f";
}

export default Constants;



// WEBPACK FOOTER //
// ./src/Constants.tsx